import {type ModuleNode} from '@backstage-components/base';
import {Alert, Text} from '@chakra-ui/react';
import {type FC} from 'react';
import {type SchemaType} from './AudioDefinition';

export const AudioPreviewComponent: FC<
  ModuleNode<'Audio', SchemaType>
> = () => {
  return (
    <Alert status="info">
      <Text>
        Audio: The audio can only be played through instructions and so it can
        not be previewed in the page.
      </Text>
    </Alert>
  );
};
